module.exports = __webpack_public_path__ + "img/minutes.8c7b8157.svg";